import React from 'react'
import './style.css'
const SocialMedia = ({icon}) => {
  return (
    <div className='SocialMedia ContactIcon'>
      <img src={icon}></img>
    </div>
  )
}

export default SocialMedia
